import { useMemo } from "react";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import {pink} from "@mui/material/colors";

export const BLANK_VALUE = "*Blank*";
const checkBoxStyle = {
  color: pink[600],
  "& .MuiSvgIcon-root": { fontSize: 20 },
  "&.Mui-checked": { color: pink[600] },
};
const MultipleSelectionFilterValues = (props) => {
  const setIsFilterActive = props.setIsFilterActive;
  const {
    column: { filterValue, preFilteredRows, setFilter, id },
  } = props;

  const options = useMemo(() => {
    let isBlank = false;
    const options ={};

    preFilteredRows.forEach((row) => {
      if ((row.values[id] === undefined || row.values[id] === null)) {
        isBlank = true;
      }
      else if(typeof row.values[id]==="object"){
        options[row.values[id]?.name]=row.values[id];
      }
      else {
        options[row.values[id]]=row.values[id];
      }
    });

    let result = {...options};

    return isBlank ? {BLANK_VALUE, ...result} : result;
  }, [id, preFilteredRows]);

  const handleChange = (e) => {
    let filters = filterValue?.multipleSelection || [];
    if (e.target.checked) {
        filters.push(options[e.target.value]);
    } else {
      const selectedIndex = filters.findIndex((filter) => filter===options[e.target.value]);
      if (selectedIndex !== -1) {
        filters.splice(selectedIndex, 1);
      }
    }

    if (filters.length === 0) {
      setFilter({
        ...filterValue,
        multipleSelection: null,
      });
      setIsFilterActive(false);
    } else{
      setFilter({
        ...filterValue,
        multipleSelection: filters,
      });
      setIsFilterActive(true);
    }
  };

  return (
    <div>
      {Object.keys(options).map((key) => (
        <div key={key}>
          <FormControlLabel
            style={{ fontSize: "20px" }}
            control={
              <Checkbox
                size={"small"}
                value={key}
                checked={
                  filterValue?.multipleSelection
                    ? filterValue.multipleSelection.includes(options[key])
                    : false
                }
                onChange={handleChange}
                labelstyle={{ color: "pink" }}
                sx={{
                  ...checkBoxStyle,
                }}
              />
            }
            label={
              <Typography style={{ fontSize: "12px" }}>{key}</Typography>
            }
          />
        </div>
      ))}
    </div>
  );
};

export default MultipleSelectionFilterValues;
